import { petsColumns } from 'common/list-configs/pets.config';

const { photo, name, type, breed, color, dateOfBirth, tag, tagExpirationDate, chipNumber, datePetAdded } = petsColumns();
export const petsInitialColumns = [photo, name, type, breed, color, dateOfBirth, tag, tagExpirationDate, chipNumber, datePetAdded];
